<template>
  <v-card outlined>
    <v-card-text class="pa-2 pa-sm-4">
      <v-row dense align="center">
        <v-col cols="12" sm="auto">
          <controller-dialog @update="getControllers" />
        </v-col>
        <v-spacer />
        <v-col cols="12" sm="4" md="3">
          <v-select
            v-model="typeFilter"
            :items="controllerTypes"
            item-text="label"
            item-value="value"
            label="Тип контроллера"
            clearable
            dense
            hide-details
          />
        </v-col>
        <v-col cols="12" sm="auto">
          <v-switch dense hide-details label="В архиве" v-model="isArchival" />
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider />

    <v-card-text>
      <list-table
        :controllers="filtered(controllers)"
        @archival="sendToArchive"
        @get-controllers="getControllers"
      />

      <template v-if="isArchival">
        <v-divider />

        <p class="text-caption my-4 pl-4">Архив</p>
        <list-table
          :controllers="filtered(archivalControllers)"
          @archival="returnFromArchive"
          @get-controllers="getControllersArchival"
        />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  getControllers,
  getControllersArchival,
  sendToArchive,
  updateController
} from "@/services/device.service";
import ControllerDialog from "@/components/devices/DeviceInformation/ControllerDialog";
import ListTable from "@/components/devices/DeviceInformation/ListTable";

export default {
  name: "ControllerOperations",
  components: { ListTable, ControllerDialog },

  data() {
    return {
      controllers: [],
      archivalControllers: [],

      isArchival: false,
      typeFilter: null,

      controllerTypes: [
        { label: "Все", value: null },
        { label: "Распберри (485)", value: 0 },
        { label: "Мониторинг", value: 2 },
        { label: "Точка выдачи ключей", value: 3 },
        { label: "ESP32", value: 5 },
        { label: "Запрос на авторизацию", value: 6 },
        { label: "---", value: -1 }
      ]
    };
  },

  watch: {
    isArchival: {
      handler(newVal) {
        return newVal ? this.getControllersArchival() : this.getControllers();
      }
    }
  },

  mounted() {
    this.getControllers();
  },

  methods: {
    filtered(items) {
      if (this.typeFilter === null || this.typeFilter === undefined) {
        return items;
      }
      if (this.typeFilter === -1) {
        const known = new Set([0, 2, 3, 5, 6]);
        return items.filter(c => !known.has(c.type));
      }
      return items.filter(c => c.type === this.typeFilter);
    },

    async getControllers() {
      try {
        this.controllers = await getControllers();

        this.controllers.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async getControllersArchival() {
      try {
        this.archivalControllers = await getControllersArchival();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async sendToArchive(controller) {
      try {
        await sendToArchive(controller.id);

        await this.updateControllersView();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async returnFromArchive(controller) {
      try {
        await updateController({
          id: controller.id,
          archival: "false",
          accessPoint: controller.accessPoint,
          token: controller.token
        });

        await this.updateControllersView();
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },

    async updateControllersView() {
      await this.getControllers();
      await this.getControllersArchival();
    }
  }
};
</script>
